import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { zodResolver } from "@hookform/resolvers/zod";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { CancelarOrdemCompraForm, CancelarOrdemCompraSchema } from "../../../schemas/OrdemCompra_cancelar/cancelar_ordem_compra";
import { useEffect } from "react";

/**
 * CancelarOrdemCompraModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: (form: CancelarOrdemCompraForm) => void;
};

export const CancelarOrdemCompraModal = ({
  open,
  saving,
  loading,
  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<CancelarOrdemCompraForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(CancelarOrdemCompraSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Cancelar ordem de compra'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-4 my-4">
        <DefaultFormInput
          name='motivo'
          label='Motivo do Cancelamento'
          multiline={true}
          rows={7}
          reactHookForm={hookForm}
        />
      </div>
    </BaseFormControlledModal>
  );
}